module.exports = __webpack_public_path__ + "img/icon-funding-light.e4f7e3dc.svg";